angular.module('admin.directives')

.directive('heightHelper', ['$rootScope', '$timeout', function($rootScope, $timeout){
  return {
    restrict: 'A',

    link: function($scope, el, attrs, ctrl){

      function lockHeight(event, toState){
        el.css('minHeight', `${el[0].offsetHeight}px`);
      };

      function releaseHeight(){
        $timeout(() => {
          el.css('minHeight', '0px');
        }, 250);
      };

      let lockCleanup = $rootScope.$on('$stateChangeStart', lockHeight);
      let releaseCleanup = $rootScope.$on('$stateChangeSuccess', releaseHeight);

      $scope.$on('$destroy', lockCleanup); // removes from $rootScope
      $scope.$on('$destroy', releaseCleanup); // removes from $rootScope
    }

  }

}]);
